export default __webpack_public_path__ + "static/FReg-Public-64702b94373ee3490b47c3c8ef98edab.jpg";